import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getUserById, updateUser } from '../../services/userService';
import { useAuth } from '../../context/AuthContext';
import { toast } from 'react-toastify';

const RED = '#B22222';
const DARK_RED = '#8B0000';
const GOLD = '#FFD700';

const UserProfile = () => {
    const [profile, setProfile] = useState(null);
    const [loading, setLoading] = useState(true);
    const [editing, setEditing] = useState(false);
    const [saving, setSaving] = useState(false);

    const [formData, setFormData] = useState({
        firstName: '',
        lastName: '',
        email: '',
        phoneNumber: '',
        address: ''
    });

    const { token, user, updateUserData } = useAuth();
    const navigate = useNavigate();

    useEffect(() => {
        if (!token) {
            navigate('/login');
            return;
        }
        fetchProfile();
    }, []);

    const fetchProfile = async () => {
        try {
            const userId = user?.id;
            if (!userId) {
                toast.error('Session expired. Login again.');
                navigate('/login');
                return;
            }
            const data = await getUserById(userId);
            setProfile(data);
            resetForm(data);
        } catch (error) {
            toast.error('Could not load profile');
        } finally {
            setLoading(false);
        }
    };

    const resetForm = (data) => {
        setFormData({
            firstName: data.firstName || '',
            lastName: data.lastName || '',
            email: data.email || '',
            phoneNumber: data.phoneNumber || '',
            address: data.address || ''
        });
    };

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    const handleSave = async (e) => {
        e.preventDefault();

        if (!formData.firstName.trim()
                || !formData.lastName.trim()) {
            return toast.warning('Enter your full name');
        }
        if (!/^[6-9]\d{9}$/.test(formData.phoneNumber)) {
            return toast.warning(
                'Enter a valid 10 digit mobile number');
        }

        setSaving(true);
        try {
            const updated = await updateUser(
                profile.id, formData);
            setProfile(updated);
            resetForm(updated);
            updateUserData(updated);
            toast.success('Profile updated');
            setEditing(false);
            window.scrollTo(0, 0);
        } catch (error) {
            toast.error(error.response?.data?.message
                || 'Update failed');
        } finally {
            setSaving(false);
        }
    };

    if (loading) return (
        <div className="text-center py-5">
            <div className="spinner-border"
                style={{ color: RED }}></div>
        </div>
    );

    if (!profile) return (
        <div className="text-center py-5">
            <h5 style={{ color: DARK_RED }}>
                Profile not found
            </h5>
        </div>
    );

    const initials = `${profile.firstName?.[0] || ''}${profile.lastName?.[0] || ''}`
        .toUpperCase();

    return (
        <div style={{ backgroundColor: '#FFF5F5' }}
            className={`pb-screen ${editing
                ? 'pb-has-action-bar' : ''}`}>

                       {/* ⚠️ Naam, email aur avatar HATA DIYE - ab wo NAVBAR
                mein hain. Do jagah hone se ek hi baat do baar
                dikhti thi.

                ⚠️ Par RATING rakhi hai - wo navbar mein nahi hai
                aur user ko dekhni chahiye. Poojari bhi user ko
                rate karta hai (dono taraf rating hai), aur user
                ko pata hona chahiye ki uski kya chhavi hai.

                ⚠️ Ab red bar nahi - navbar pehle se red hai. Do
                red bar ek ke neeche ek bhaari lagti. */}
            {profile.rating > 0 && (
                <div style={{
                    backgroundColor: 'white',
                    borderBottom: `1px solid ${GOLD}`,
                    padding: '10px 16px'
                }}>
                    <p className="mb-0"
                        style={{
                            color: '#666',
                            fontSize: '12px'
                        }}>
                        ⭐ {profile.rating} &middot;{' '}
                        {profile.totalRatings} rating(s) from poojaris
                    </p>
                </div>
            )}

            <div className="container"
                style={{ maxWidth: '520px' }}>
                <div className="py-3">

                    {!editing ? (
                        /* ============ VIEW MODE ============ */
                        <>
                            <div className="d-flex justify-content-between align-items-center mb-3">
                                <h6 className="fw-bold mb-0"
                                    style={{ color: DARK_RED }}>
                                    My account
                                </h6>
                                <button
                                    className="btn btn-sm fw-bold"
                                    style={{
                                        backgroundColor: RED,
                                        color: GOLD,
                                        border: 'none'
                                    }}
                                    onClick={() => {
                                        setEditing(true);
                                        window.scrollTo(0, 0);
                                    }}>
                                    Edit
                                </button>
                            </div>

                            <div className="card mb-3"
                                style={{
                                    borderRadius: '12px',
                                    border: `1px solid ${GOLD}`
                                }}>
                                <div className="card-body p-3">
                                    {[
                                        {
                                            label: 'Name',
                                            value: `${profile.firstName} ${profile.lastName}`
                                        },
                                        {
                                            label: 'Email',
                                            value: profile.email
                                        },
                                        {
                                            label: 'Phone',
                                            value: profile.phoneNumber
                                        },
                                        {
                                            label: 'Address',
                                            value: profile.address
                                                || 'Not added'
                                        },
                                        {
                                            label: 'Member since',
                                            value: profile.createdAt
                                                ? new Date(
                                                    profile.createdAt)
                                                    .toLocaleDateString()
                                                : '-'
                                        }
                                    ].map((row, i) => (
                                        <div key={i}
                                            className="d-flex justify-content-between py-2"
                                            style={{
                                                borderBottom:
                                                    i < 4
                                                    ? '1px solid #eee'
                                                    : 'none',
                                                fontSize: '13px'
                                            }}>
                                            <span className="text-muted flex-shrink-0 me-3">
                                                {row.label}
                                            </span>
                                            <strong className="text-end"
                                                style={{
                                                    color: DARK_RED,
                                                    wordBreak:
                                                        'break-word'
                                                }}>
                                                {row.value}
                                            </strong>
                                        </div>
                                    ))}
                                </div>
                            </div>

                            {/* Quick links */}
                            <div className="card"
                                style={{
                                    borderRadius: '12px',
                                    border: `1px solid ${GOLD}`,
                                    overflow: 'hidden'
                                }}>
                                {[
                                    {
                                        icon: '📅',
                                        label: 'My bookings',
                                        onClick: () =>
                                            navigate('/home',
                                                { state: {
                                                    tab: 'active'
                                                }})
                                    },
                                    {
                                        icon: '💰',
                                        label: 'My payments',
                                        onClick: () =>
                                            navigate('/my-payments')
                                    },
                                    {
                                        icon: '⭐',
                                        label: 'My reviews',
                                        onClick: () =>
                                            navigate('/my-reviews')
                                    }
                                ].map((item, i) => (
                                    <div key={i}
                                        onClick={item.onClick}
                                        className="d-flex justify-content-between align-items-center p-3"
                                        style={{
                                            cursor: 'pointer',
                                            borderBottom: i < 2
                                                ? '1px solid #eee'
                                                : 'none'
                                        }}>
                                        <span style={{
                                            fontSize: '14px',
                                            color: DARK_RED,
                                            fontWeight: 600
                                        }}>
                                            {item.icon} {item.label}
                                        </span>
                                        <span style={{
                                            color: '#ccc',
                                            fontSize: '18px'
                                        }}>
                                            ›
                                        </span>
                                    </div>
                                ))}
                            </div>
                        </>
                    ) : (
                        /* ============ EDIT MODE ============ */
                        <form onSubmit={handleSave}>

                            <h6 className="fw-bold mb-3"
                                style={{ color: DARK_RED }}>
                                Edit profile
                            </h6>

                            <div className="mb-3">
                                <label className="form-label fw-bold"
                                    style={{
                                        color: DARK_RED,
                                        fontSize: '13px'
                                    }}>
                                    First name
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    name="firstName"
                                    value={formData.firstName}
                                    onChange={handleChange}
                                    style={{ borderColor: GOLD }}
                                />
                            </div>

                            <div className="mb-3">
                                <label className="form-label fw-bold"
                                    style={{
                                        color: DARK_RED,
                                        fontSize: '13px'
                                    }}>
                                    Last name
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    name="lastName"
                                    value={formData.lastName}
                                    onChange={handleChange}
                                    style={{ borderColor: GOLD }}
                                />
                            </div>

                            <div className="mb-3">
                                <label className="form-label fw-bold"
                                    style={{
                                        color: DARK_RED,
                                        fontSize: '13px'
                                    }}>
                                    Email
                                </label>
                                <input
                                    type="email"
                                    className="form-control"
                                    value={formData.email}
                                    disabled
                                    style={{
                                        backgroundColor: '#f5f5f5'
                                    }}
                                />
                                <small className="text-muted">
                                    Email cannot be changed
                                </small>
                            </div>

                            <div className="mb-3">
                                <label className="form-label fw-bold"
                                    style={{
                                        color: DARK_RED,
                                        fontSize: '13px'
                                    }}>
                                    Mobile number
                                </label>
                                <input
                                    type="tel"
                                    className="form-control"
                                    placeholder="10 digit number"
                                    maxLength="10"
                                    inputMode="numeric"
                                    value={formData.phoneNumber}
                                    onChange={e =>
                                        setFormData({
                                            ...formData,
                                            phoneNumber:
                                                e.target.value
                                                    .replace(
                                                        /\D/g, '')
                                        })}
                                    style={{ borderColor: GOLD }}
                                />
                            </div>

                            <div className="mb-3">
                                <label className="form-label fw-bold"
                                    style={{
                                        color: DARK_RED,
                                        fontSize: '13px'
                                    }}>
                                    Address
                                </label>
                                <textarea
                                    className="form-control"
                                    name="address"
                                    rows="3"
                                    placeholder="Where do you usually hold poojas?"
                                    value={formData.address}
                                    onChange={handleChange}
                                    style={{ borderColor: GOLD }}>
                                </textarea>
                                <small className="text-muted">
                                    This will be pre-filled when
                                    you book
                                </small>
                            </div>
                        </form>
                    )}
                </div>
            </div>

            {/* ===== STICKY ACTION BAR - edit mode ===== */}
            {editing && (
                <div className="pb-action-bar">
                    <button
                        className="btn btn-secondary flex-fill"
                        onClick={() => {
                            resetForm(profile);
                            setEditing(false);
                            window.scrollTo(0, 0);
                        }}
                        disabled={saving}>
                        Cancel
                    </button>
                    <button
                        className="btn flex-fill fw-bold"
                        style={{
                            backgroundColor: RED,
                            color: GOLD,
                            border: 'none'
                        }}
                        onClick={handleSave}
                        disabled={saving}>
                        {saving ? 'Saving...' : 'Save changes'}
                    </button>
                </div>
            )}
        </div>
    );
};

export default UserProfile;